export default {
  resultLabel: "Errors and notifications found",
  columnNames: {
    origin: "Origin",
    fieldName: "field name",
    validationType: "Validation type",
    validationRule: "Validation rule",
    ruleDescription: "Rule description",
    services: "Services",
    consecutive: "Consecutive",
    patient: "Patient",
  },
  emptyDataLabel: "No results found",
};
